import ClimateIcon from '@/assets/icons/controlGroup/climate.png';
import IrrigationFertigationIcon from '@/assets/icons/controlGroup/irrigation-fertigation.png';

export const iconMap: Record<string, string> = {
  climate: ClimateIcon,
  irrigationFertigation: IrrigationFertigationIcon
};
